export default __webpack_public_path__ + "static/media/tictactoe.4af49b3f.webp";